import React from 'react';
import { CheckCircle2Icon, GraduationCapIcon, WrenchIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const pillars = [{
  icon: CheckCircle2Icon,
  title: 'Select',
  desc: 'Evaluate what belongs in your office, how it serves patients, and whether it aligns with practice goals.'
}, {
  icon: GraduationCapIcon,
  title: 'Train',
  desc: 'Give your staff a clear path to confidently understand, introduce, and use the technology.'
}, {
  icon: WrenchIcon,
  title: 'Implement',
  desc: 'Build a practical plan for bringing the right modality into your day-to-day practice.'
}];
export function Process() {
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-231" data-mp="1dfl8dn0pb1z">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-232" data-mp="1bkw0n4pqws3">
        <SectionHeading eyebrow="The JAG Approach" title="Don't Buy the Hype. Buy the Right Fit." description="JAG helps doctors evaluate what belongs in their office, how it serves patients, how staff will use it, and how it can be implemented profitably." align="center" data-id="element-233" data-mp="39sfp5avpl2sz" />
        <div className="mx-auto mt-14 grid max-w-5xl gap-7 md:grid-cols-3" data-id="element-234" data-mp="2rpln1lz1pbdm">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <div key={pillar.title} className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm" data-id="element-235" data-mp="30jgig2ad7ng2" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-236" data-mp="23vagxo8qpb60">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy text-white" data-id="element-237" data-mp="28stusn1izlxf">
                    <Icon className="h-5 w-5" data-id="element-238" data-mp="2cs2q3wc7rrv3" />
                  </span>
                  <span className="font-display text-3xl font-extrabold text-slate-200" data-id="element-239" data-mp="2hsz08rn5sa8y">
                    0{index + 1}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-navy" data-id="element-240" data-mp="3t7vssbijxhl2">
                  {pillar.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/75" data-id="element-241" data-mp="1t4l6yh6s0ojc">
                  {pillar.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}